<ion-list>
  <ion-item *ngFor="let item of topItems" [hidden]="!item.show" [routerLink]="[item.route]" [routerLinkActive]="item.route" routerDirection="forward" detail="false">
  <ion-icon slot="start" [name]="item.iconName" [color]="item.iconColor"></ion-icon>
  <ion-label >{{ item.label | translate }}</ion-label>
</ion-item>
</ion-list>

<ion-list>
@if (authService.authUserSignal()?.role.value > 199) {
  <ion-item button [routerLink]="['/smart-venues']" routerLinkActive="/smart-venues" routerLinkActive="router-link-active">
  <ion-icon slot="start" name="bulb" color="secondary"></ion-icon>
  <ion-label>{{ 'Smart venues' | translate }}</ion-label>
</ion-item>
}

@if (authService.authUserSignal()?.allowMatchSubscription && authService.authUserSignal()?.role?.value !== 500) {
  <ion-item button [routerLink]="['/generate-token']" routerLinkActive="/generate-token" routerLinkActive="router-link-active">
    <ion-icon slot="start" name="key" color="secondary"></ion-icon>
    <ion-label>{{ 'Generate Token' | translate }}</ion-label>
  </ion-item>
  
  <ion-item button [routerLink]="['/manage-tokens']" routerLinkActive="/manage-tokens" routerLinkActive="router-link-active">
    <ion-icon slot="start" name="settings" color="secondary"></ion-icon>
    <ion-label>{{ 'Manage Tokens' | translate }}</ion-label>
  </ion-item>
}

<!-- HIDE MY COACHES FOR NOW-->
<!-- @if (authService.authUserSignal()?.role.value > 499) {
<ion-item button [routerLink]="['/my-coaches']" routerLinkActive="router-link-active" routerDirection="forward"
  detail="false">
  <ion-icon slot="start" name="school" color="secondary"></ion-icon>
  <ion-label>{{ 'My Coaches' | translate }}</ion-label>
</ion-item>
} -->
<ion-item>
  <ion-icon slot="start" name="sunny" color="secondary"></ion-icon>
  <span>{{ 'Dark mode' | translate }}</span>
  <ion-toggle slot="end" [checked]="isDarkMode" (ionChange)="toggleDarkMode($event)"></ion-toggle>
</ion-item>

<ion-item [routerLink]="['/feedback']" routerLinkActive="/feedback" routerDirection="forward" detail="false">
  <ion-icon slot="start" name="chatbox-ellipses" color="secondary"></ion-icon>
  <ion-label>{{ 'Feedback' | translate }}</ion-label>
</ion-item>

<!-- <ion-item [routerLink]="['/blog']" routerLinkActive="/blog" routerDirection="forward" detail="false">
  <ion-icon slot="start" name="information-circle" color="secondary"></ion-icon>
  <ion-label>{{ 'Blog' | translate }}</ion-label>
</ion-item> -->

<ion-item button (click)="logout()" routerDirection="root" detail="false">
  <ion-icon slot="start" name="log-out" color="secondary"></ion-icon>
  <ion-label>{{ 'Log Out' | translate }}</ion-label>
</ion-item>

</ion-list>

@if (authService.authUserSignal()?.role.value > 299) {
<ion-list>
<ion-item button [routerLink]="['/admin']" routerLinkActive="/admin" routerLinkActive="router-link-active">
  <ion-label>{{ 'Admin' | translate }}</ion-label>
</ion-item>
</ion-list>
}